module.exports = __webpack_public_path__ + "static/media/barcodeTick.02a4bf0e.svg";